import { GenericPortal as Portal } from "./GenericPortal";
import { usePortalContainer } from "./GenericPortal.hooks";

export const GenericPortal = {
  Portal,
  usePortalContainer,
};
